import { fetchWrapper } from "utils/apiFetch";

const API_BASE = "https://pro.mokshiq.in";

// Helper to generate a unique idempotent order ID
export const generateOrderId = (prefix = "BILL") => {
  const rand = Math.random().toString(36).substring(2, 10).toUpperCase();
  return `${prefix}_${Date.now().toString(36).toUpperCase()}_${rand}`;
};

export const billPaymentApi = {
  // 1. Fetch BBPS Categories
  getCategories: async () => {
    return await fetchWrapper(`${API_BASE}/api/v1/bill-payment/bbps/categories`);
  },

  // 2. Fetch Operators for a category
  getOperators: async (category) => {
    const params = new URLSearchParams({ category });
    return await fetchWrapper(`${API_BASE}/api/v1/bill-payment/bbps/operators?${params.toString()}`);
  },

  // 3. BBPS Bill Fetch
  fetchBbpsBill: async ({ mobile, opcode, consumerNumber }) => {
    return await fetchWrapper(`${API_BASE}/api/v1/bill-payment/bbps/bill-fetch`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        mobile,
        opcode,
        consumer_number: consumerNumber,
        orderid: generateOrderId("BF"),
      }),
    });
  },

  // 4. BBPS Bill Pay
  payBbpsBill: async ({ mobile, opcode, consumerNumber, amount, fetchId, pin }) => {
    return await fetchWrapper(`${API_BASE}/api/v1/bill-payment/bbps/bill-pay`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        mobile,
        opcode,
        consumer_number: consumerNumber,
        amount: parseFloat(amount),
        fetch_id: fetchId,
        orderid: generateOrderId("BPAY"),
        pin,
      }),
    });
  },

  // 5. Status Check (Query by Order ID)
  checkStatus: async (orderid) => {
    return await fetchWrapper(`${API_BASE}/api/v1/bill-payment/bbps/status?orderid=${encodeURIComponent(orderid)}`);
  },

  // 6. Credit Card Bill Fetch
  fetchCreditCardBill: async ({ mobile, card, opcode }) => {
    return await fetchWrapper(`${API_BASE}/api/v1/bill-payment/credit-card/bill-fetch`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        mobile,
        card: String(card).replace(/\s+/g, ""),
        opcode,
        orderid: generateOrderId("CCF"),
      }),
    });
  },

  // 7. Credit Card Bill Pay
  payCreditCardBill: async ({ mobile, card, amount, fetchId, opcode, pin }) => {
    return await fetchWrapper(`${API_BASE}/api/v1/bill-payment/credit-card/bill-pay`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        mobile,
        card: String(card).replace(/\s+/g, ""),
        amount: parseFloat(amount),
        fetch_id: fetchId,
        opcode,
        orderid: generateOrderId("CCPAY"),
        pin,
      }),
    });
  },
};
